import ProjectHttpClient from "../core/infrastructure/clients/v1/ProjectHttpClient";
import GuestHttpClient from "../core/infrastructure/clients/v1/GuestHttpClient";
import OrganizationHttpClient from "../core/infrastructure/clients/v1/OrganizationHttpClient";
import AdvisorHttpClient from "../core/infrastructure/clients/v2/AdvisorHttpClient";
import AdvisorFeedbackHttpClient from "../core/infrastructure/clients/v2/AdvisorFeedbackHttpClient";
import ProjectFeedbackHttpClient from "../core/infrastructure/clients/v2/ProjectFeedbackHttpClient";
import UserHttpClient from "../core/infrastructure/clients/v2/UserHttpClient";
import CompanyHttpClient from "../core/infrastructure/clients/v2/CompanyHttpClient";
import AdminHttpClient from "../core/infrastructure/clients/v2/AdminHttpClient";
import SchedulerHttpClient from "../core/infrastructure/clients/v2/SchedulerHttpClient";
import AdvisorTouchpointHttpClient from "../core/infrastructure/clients/v2/AdvisorTouchpointHttpClient";
import AdminTouchpointHttpClient from "../core/infrastructure/clients/v2/AdminTouchpointHttpClient";
import AdminMeetingHttpClient from "../core/infrastructure/clients/v2/AdminMeetingHttpClient";
import AdminUserHttpClient from "../core/infrastructure/clients/v2/AdminUserHttpClient";
import TouchpointHttpClient from "../core/infrastructure/clients/v2/TouchpointHttpClient";

const ClientProvider = {
    provideProjectClient: () => {
        return new ProjectHttpClient();
    },

    provideGuestClient: () => {
        return new GuestHttpClient();
    },
    provideOrganizationClient: () => {
        return new OrganizationHttpClient();
    },

    provideAdvisorClient: () => {
        return new AdvisorHttpClient();
    },

    provideAdvisorFeedbackClient: () => {
        return new AdvisorFeedbackHttpClient();
    },

    provideProjectFeedbackClient: () => {
        return new ProjectFeedbackHttpClient();
    },

    provideUserClient: () => {
        return new UserHttpClient();
    },

    provideCompanyClient: () => {
        return new CompanyHttpClient();
    },

    provideAdminClient: () => {
        return new AdminHttpClient();
    },

    provideSchedulerClient: () => {
        return new SchedulerHttpClient();
    },

    provideAdvisorTouchpointClient: () => {
        return new AdvisorTouchpointHttpClient();
    },

    provideAdminTouchpointClient: () => {
        return new AdminTouchpointHttpClient();
    },

    provideAdminMeetingClient: () => {
        return new AdminMeetingHttpClient();
    },

    provideAdminUserClient: () => {
        return new AdminUserHttpClient();
    },

    provideTouchpointClient: () => {
        return new TouchpointHttpClient();
    }
}

export default ClientProvider;